<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch01">
<div class="chapterHead">
<h2 class="chapterTitle" style="text-indent: 0%;"><span class="bold"><em class="italic">Paris, 1971</em></span></h2></div>
<div class="chapterBody">
<p class="chapterOpenerText" style="text-indent: 0%;">My name is Mathilde Kschessinska, and I was the greatest Russian ballerina on the imperial stages. But the world I was born to, the world I was bred for, is gone, and all the players in it are also gone—dead, murdered, exiled, walking ghosts. I am one of those ghosts. Today in the Soviet Union, it is forbidden to utter my name. The authorities have wiped it from their histories of the theater. I am ninety-nine years old, an old lady with a hairnet and a pinched mouth and yet they still fear me. I stood barely five feet at the height of my fame—my shoe size a three—but now I neither stand nor walk. I sit with my eyes closed in my Paris home of fifty years and live in the past, the mementos of my old Petersburg life all around—sepia photographs of the imperial family and of my son, my father’s icon of Our Lady of Czestokowa, his ring with the arms of Count Krassinsky, a medal from the tunic of my husband’s old uniform from the Horse Guards. Like those things, I, too, am a relic. But traces of that old world remain, you know, buried somewhere beneath this world. The Winter Palace. The Maryinsky Theater. Tsarskoye Selo. Peterhof. I see that world more clearly than I see the avenues and trees outside my window here in the 16th Arrondissement. What is there to interest me here? The hippie boys in their psychedelic pants, the hippie girls in their short skirts and long, uncombed hair? The world I knew was grand, the court more elaborate than the French court under Louis XIV. I was the lover of two grand dukes, the mistress of the tsar. The last tsar.</p>
<p class="para" style="text-indent: 5%;">He called me Little K.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780374207304_ch01.vue?46c27b82